<template>
  <div class="transactional-profile">
    <v-container>
      <h3 class="text-center" style="color: #434343; padding: 8px">
      </h3>
       <v-form ref="transactionProfile">
      <v-row class="ma-0">
        <v-col cols="6">
          <label for="">Processing Currencies <span class="red--text"><strong>* </strong></span></label>
          <v-combobox
            :rules="TextRules"
            color="#434343"
            v-model="transactional_profile.processing_currency"
            clearable
            label=""
            multiple
            outlined
            placeholder="Enter Processing Currencies"
            append-icon="mdi-abc"
          >
            <template
              v-slot:selection="{ attrs, item, select, selected, index }"
              style="padding-top: 10px !important"
            >
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                class="my-1 mt-2"
                small
                @click="select"
                @click:close="
                  transactional_profile.processing_currency.splice(index, 1)
                "
              >
                <strong>{{ item }}</strong
                >&nbsp;
              </v-chip>
            </template>
          </v-combobox>
          <blockquote style="line-height: 1; margin-top: -21px">
            <small style="font-size: 11px" class="grey--text"
              >Press the enter or tab button to proceed with the enlistings of
              the processing currencies</small
            >
          </blockquote>
        </v-col>
        <v-col cols="6">
          <label for="">Average Transaction Value <span class="red--text"><strong>* </strong></span></label>
          <v-text-field
            v-model="transactional_profile.average_trx"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Average Transaction Value"
            label=""
            dense
            name="transaction_avg_transaction_val"
            id="transaction_avg_transaction_val"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">Minimum Transaction Value <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.minimum_trx"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Minimum Transaction Value"
            label=""
            dense
            name="transaction_min_transaction_val"
            id="transaction_min_transaction_val"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">Maximum Transaction Value <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.maximum_trx"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Maximum Transaction Value"
            label=""
            dense
            name="transaction_max_transaction_val"
            id="transaction_max_transaction_val"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">Estimated Monthly Volume <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.estimated_monthly_volume"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Estimated Monthly Volume"
            label=""
            dense
            name="transaction_est_monthly_vol"
            id="transaction_est_monthly_vol"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">PCI DSS Compliant <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.company_compliant"
            :rules="TextRules"  
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter PCI DSS Compliant"
            label=""
            dense
            name="transaction_pci_compliant"
            id="transaction_pci_compliant"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <small
                  >IS YOUR COMPANY PCI DSS COMPLIANT?<br />(IF YES, PLEASE
                  SPECIFY)</small
                >
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="6">
          <label for="">Fraud Prevention Techniques <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.fraud_prevent_techniques"
            :rules="TextRules"
            color="#434343"
            maxlength="51"
            outlined
            placeholder="Enter Fraud Prevention Techniques"
            label=""
            dense
            name="transaction_prevention_techniques"
            id="transaction_prevention_techniques"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <small
                  >DO YOU USE ANY FRAUD PREVENTION TECHNIQUES?<br />(IF YES,
                  PLEASE SPECIFY)</small
                >
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="6">
          <label for="">Blocked Countries <span class="red--text"><strong>* </strong></span></label>
          <v-combobox
            color="#434343"
            :rules="TextRules"
            v-model="transactional_profile.block_countries_trx"
            clearable
            label=""
            multiple
            class="adjust-combox"
            outlined
            placeholder="Enter Blocked Countries"
          >
            <template
              v-slot:selection="{ attrs, item, select, selected, index }"
              style="padding-top: 10px !important"
            >
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                class="my-1 mt-2"
                small
                @click="select"
                @click:close="
                  transactional_profile.block_countries_trx.splice(index, 1)
                "
              >
                <strong>{{ item }}</strong
                >&nbsp;
              </v-chip>
            </template>

            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <small
                  >DO YOU BLOCK ANY COUNTRIES FOR TRANSACTIONS?<br />(IF YES,
                  PLEASE SPECIFY)</small
                >
              </v-tooltip>
            </template>
            <!-- </v-text-field> -->
          </v-combobox>
          <blockquote style="line-height: 1; margin-top: -22px">
            <small style="font-size: 11px" class="grey--text"
              >Press the enter or tab button to proceed with the enlistings of
              the blocked countries</small
            >
          </blockquote>
        </v-col>

        <v-col cols="6" class="mt-4">
          <!-- <label for="">Average Transaction Value</label> -->

          <v-checkbox
            v-model="transactional_profile.is_holding_data"
            :label="`Do You Process any Card Holder Data?`"
            class="mt-1"
            color="#434343"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" style="color: #434343">
          <h5 class="mt-5 mb-5">
            Indicate The Average Percentage of Transactions Volume Per Region
          </h5></v-col
        >

        <v-col cols="6">
          <label for="">United States (USA) <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.USA_trx_volume"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter United States (USA)"
            label=""
            dense
            name="transaction_vol_usa_percentage"
            id="transaction_vol_usa_percentage"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">Europe <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.EU_trx_volume"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Europe"
            label=""
            dense
            name="transaction_vol_eu_percentage"
            id="transaction_vol_eu_percentage"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <label for="">Asia <span class="red--text"><strong>* </strong></span></label>

          <v-text-field
            v-model="transactional_profile.ASIA_trx_volume"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Asia"
            label=""
            dense
            name="transaction_vol_asia_percentage"
            id="transaction_vol_asia_percentage"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <label for="">Canada <span class="red--text"><strong>* </strong></span></label>
          <v-text-field
            v-model="transactional_profile.CA_trx_volume"
            :rules="IntRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Canada"
            label=""
            dense
            name="transaction_vol_canada_percentage"
            id="transaction_vol_canada_percentage"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <label for="">Others</label>
          <v-text-field
            v-model="transactional_profile.others_trx_volume"
            :rules="IntOtherRules"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Others"
            label=""
            dense
            name="transaction_vol_others_percentage"
            id="transaction_vol_others_percentage"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
       </v-form>
      <v-btn  class="mr-2 float-end next-btn appBlue white--black ml-2" @click="checkForm()"
        >Next</v-btn
      >

      <v-btn text @click="updateIndex(5)" class="float-end adjust-pre-btn mr-1 next-btn liteGray black--text">
        Previous
      </v-btn>
    </v-container>
    <!-- Error Snackbar -->
    <v-snackbar style="z-index: 999" top centered v-model="snackbarError">
      {{ this.errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbarError = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Confirmation Dialog Box -->
    <v-dialog v-model="dialog" width="500" :persistent="true">
      <v-card>
        <v-card-title class="subtitle-1 appBlack--text"> Confirmation </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5 ">
          Are you sure you want to submit application form, you will not be able
          to edit it again.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="next-btn liteGray black--text"
            :disabled="submitBtn == true"
            @click="(dialog = false), (loader = false)"
          >
            Cancel
          </v-btn>
          <v-btn
          
            class="next-btn appBlue white--black ml-2"
            @click="updatePaymentInstructions()"
            :loading="loader"
            :disabled="loader"
          >
            Yes, proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { showSnackbar } from "../utils/GlobalActions";
import { mapGetters } from "vuex";
export default {
  name: "TransactionalProfile",
  data() {
    return {
      search: "",
      searchCountries: "",
      submitBtn: false,
      dialog: false,
      loader: false,
      snackbarError: false,
      errorText: "",
      IntOtherRules: [
        v => v >= 0 || "Negative values not allowed"
      ],
      TextRules: [
        v => v.length > 0 || "Required",
        v => (v) => !!v || "Required",
      ],
      IntRules: [
        v => v.length > 0 || "Required",
        v => !!v || "Required",
        v => v >= 0 || "Negative values not allowed",
      ],
      // TextRules: [(v) => !!v || "Required"],
      transactional_profile: {
        processing_currency: [],
        block_countries_trx: [],
        average_trx: "",
        minimum_trx: "",
        maximum_trx: "",
        estimated_monthly_volume: "",
        company_compliant: "",
        fraud_prevent_techniques: "",
        is_holding_data: false,
        USA_trx_volume: "",
        EU_trx_volume: "",
        ASIA_trx_volume: "",
        CA_trx_volume: "",
        others_trx_volume: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getCryptoID",
      "getUserId",
      "getFormId",
      "getCorporateInfo",
      "getPrimaryContact",
      "getFinancialContact",
      "getTechnicalContact",
      "getDirectorsDetails",
      "getShareholdersDetails",
      "getBusinessProfile",
      "getTransactionalProfile",
      "getWebsiteDetails",
      "getWebsiteContent",
      "getCryptoCurrencyWallet",
      "getBankingInformation",
      "getCorporateName",
      "getSelectedFile",
      "getCorporateInfoError",
      "getPrimaryContactError",
      "getDirectorsDetailsError",
      "getShareholdersDetailsError",
      "getBusinessProfileError",
      "getWebsiteDetailsError",
      "getWebsiteContentError",
      "getPaymentInstructionsError",
      "getBankingInformationError",
      "getTransactionalProfileError",
      "getStepperCount",
      "getDocument",
      "getTransactionID"
    ]),
  },
  methods: {
    updatePaymentInstructions() {
      this.loader = true;
      axios
        .post(
          "/createTransactionalProfile",
          {
            transactional_profile: this.transactional_profile,
            transactional_profile_form_id: this.getTransactionID,
            form_id: this.getFormId,
            user_id: this.getUserId,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          // console.log(res.data, "directors");
          if(res.status==201){
            this.dialog=false;
            this.loader=false;
             this.updateIndex(7);
          }
        })
        .catch((err) => {
          console.log(err.response, "transaction_Profile_err");
           showSnackbar("Error!",err.response.data.message,"error");
           this.loader=false;
        });
        // this.updateIndex(7);
    },
    checkForm() {
      if (!this.$refs.transactionProfile.validate()) {
         this.$store.dispatch("updateTransactionalProfileError", true);
      }
      else{
        this.$store.dispatch("updateTransactionalProfileError", false);

      }
      console.log("test", 
      this.getTransactionalProfileError,
      this.getPrimaryContactError,
      this.getShareholdersDetailsError,
      this.getDirectorsDetailsError,
      this.getBusinessProfileError,
      this.getCorporateInfoError,);

      if (
        this.getCorporateInfoError ||
        this.getPrimaryContactError ||
        this.getShareholdersDetailsError ||
        this.getDirectorsDetailsError ||
        this.getTransactionalProfileError ||
        this.getBusinessProfileError
      ) {
        // this.errorText = "Please fill all the required fields";
        showSnackbar("Error!", "Please fill all the required fields","error");
        // this.snackbarError = true;
        this.loader = false;
        this.dialog = false;
        return;
      } else {
        console.log("dasda");
      }
      this.dialog = true;
    },

    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
    updateItems() {
      if (this.search !== null && this.search !== "") {
        this.$nextTick(() => {
          this.transactional_profile.processing_currency.push(
            ...this.search.split(",")
          );
          this.$nextTick(() => {
            this.search = "";
          });
        });
      }
    },
    updateCountries() {
      if (this.searchCountries !== null && this.searchCountries !== "") {
        this.$nextTick(() => {
          this.transactional_profile.block_countries_trx.push(
            ...this.searchCountries.split(",")
          );
          this.$nextTick(() => {
            this.searchCountries = "";
          });
        });
      }
    },
    updateTransactionalProfile() {
      this.updateIndex(4);

      axios
        .post(
          "/createTransactionalProfile",
          {
            form_id: this.getFormId,
            user_id: this.getUserId,
            transactional_profile_form_id: this.getTransactionID,
            transactional_profile: this.transactional_profile,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          // console.log(res.data, "transactional Profile");
        })
        .catch((err) => {
          console.log(err.response, "transactional error");
        });
      this.$store.dispatch("incrementStepper");
    },
  },
  mounted() {
    axios
      .post(
        "/transactionalProfile",
        {
          form_id: this.getFormId,
          user_id: this.getUserId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        // console.log(res.data, "transactional Data");
        if (res.data.getTransactionalProfile.processing_currency == "") {
          this.transactional_profile.processing_currency = "";
        } else {
          JSON.parse(
            res.data.getTransactionalProfile.processing_currency
          ).filter((currency) => {
            this.transactional_profile.processing_currency.push(currency);
          });
        }
        if (res.data.getTransactionalProfile.block_countries_trx == "") {
          this.transactional_profile.block_countries_trx = "";
        } else {
          JSON.parse(
            res.data.getTransactionalProfile.block_countries_trx
          ).filter((country) => {
            this.transactional_profile.block_countries_trx.push(country);
          });
        }
        this.transactional_profile.average_trx =
          res.data.getTransactionalProfile.average_trx == null
            ? ""
            : res.data.getTransactionalProfile.average_trx;
        this.transactional_profile.minimum_trx =
          res.data.getTransactionalProfile.minimum_trx == null
            ? ""
            : res.data.getTransactionalProfile.minimum_trx;
        this.transactional_profile.maximum_trx =
          res.data.getTransactionalProfile.maximum_trx == null
            ? ""
            : res.data.getTransactionalProfile.maximum_trx;
        this.transactional_profile.estimated_monthly_volume =
          res.data.getTransactionalProfile.estimated_monthly_volume == null
            ? ""
            : res.data.getTransactionalProfile.estimated_monthly_volume;
        this.transactional_profile.company_compliant =
          res.data.getTransactionalProfile.company_compliant == null
            ? ""
            : res.data.getTransactionalProfile.company_compliant;
        this.transactional_profile.fraud_prevent_techniques =
          res.data.getTransactionalProfile.fraud_prevent_techniques == null
            ? ""
            : res.data.getTransactionalProfile.fraud_prevent_techniques;
        (this.transactional_profile.is_holding_data =
          res.data.getTransactionalProfile.is_holding_data == 0 ? false : true),
          (this.transactional_profile.USA_trx_volume =
            res.data.getTransactionalProfile.USA_trx_volume == null
              ? ""
              : res.data.getTransactionalProfile.USA_trx_volume);
        this.transactional_profile.EU_trx_volume =
          res.data.getTransactionalProfile.EU_trx_volume == null
            ? ""
            : res.data.getTransactionalProfile.EU_trx_volume;
        this.transactional_profile.ASIA_trx_volume =
          res.data.getTransactionalProfile.ASIA_trx_volume == null
            ? ""
            : res.data.getTransactionalProfile.ASIA_trx_volume;
        this.transactional_profile.CA_trx_volume =
          res.data.getTransactionalProfile.CA_trx_volume == null
            ? ""
            : res.data.getTransactionalProfile.CA_trx_volume;
        this.transactional_profile.others_trx_volume =
          res.data.getTransactionalProfile.others_trx_volume == null
            ? ""
            : res.data.getTransactionalProfile.others_trx_volume;
      })
      .catch((err) => {
        console.log(err, "transactional error mount");
      });
    this.TextRules.push((v) => v.length <= 50 || "Max 50 characters");
    // this.transactional_profile = this.$store.getters.getTransactionalProfile;
  },
};
</script>

<style scoped>
.adjust-pre-btn {
  font-size: 11px !important;
}
.adjust-combox {
}
</style>